import { LOADING } from "./actionConsts";
import { AllActions } from "../../types";

export function loading(): AllActions {
  return {
    type: LOADING,
  };
}
export function loadingSingleCountry(): AllActions {
  return {
    type: LOADING,
  };
}
